<template>
	<span class="component theme-switcher">
		<form 
			method="post" 
			ref="themeForm"
			class="uk-form-stacked" 
			accept-charset="UTF-8" 
			autocomplete="off" 
			@submit.prevent="submitForm"
			>
			<input type="hidden" :name="csrfName" :value="csrfToken">	
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="userId">
				<button
					type="button"
					class="theme-switcher__button"
					:aria-label="isDarkMode ? 'Licht thema inschakelen' : 'Donker thema inschakelen'"
					@click="toggleSwitch"
				>
					<Moon v-if="isDarkMode" :size="20" :stroke-width="2" />
					<Sun v-else :size="20" :stroke-width="2" />
				</button>
		</form>
	</span>
</template>

<script>
	
import Cookies from 'js-cookie';
import axios from 'axios';
import Moon from '@lucide/vue/dist/esm/icons/moon.mjs';
import Sun from '@lucide/vue/dist/esm/icons/sun.mjs';

export default {
	name: "theme-switcher",
	components: {
		Moon,
		Sun,
	},
	props: {
		userId: {
			type: Number,
			default: 0,
		},
		dark: {
			type: Boolean,
			default: false
		} 
	},
	data() {
		return {
			formKey: null,
			isDarkMode: null,
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName;
		},
		csrfToken() {
			return window.csrfTokenValue;
		},
	},
	mounted() {
	  this.$logger("app/components/theme-switcher/mounted");
	
	  this.formKey = "theme-switcher-" + this.$helper.getRandInteger();
	
	  // 1. If logged in: trust server-prop `dark`
	  if (this.userId > 0) {
		this.isDarkMode = this.dark;
	  } else {
		// 2. If anonymous: check cookie first
		const cookieValue = Cookies.get("darkTheme");
		if (cookieValue === "1") {
		  this.isDarkMode = true;
		} else if (cookieValue === "0") {
		  this.isDarkMode = false;
		} else {
		  // no cookie yet → fall back to server-prop
		  this.isDarkMode = this.dark;
		}
	  }
	
	  // Apply theme immediately
	  this.applyTheme();
	
	  console.log("theme-switcher initial darkMode:", this.isDarkMode);
	},
	created() {
		this.$logger("app/components/theme-switcher/created");
	},
	methods: {
		applyTheme() {

			var component = this;
						
			if (component.isDarkMode) {
				document.body.classList.add('dark');
			} else {		
				document.body.classList.remove("dark");
			}
		},
		toggleSwitch(e) {

			var component = this;
						
			if(component.isDarkMode) {
				component.isDarkMode = false;
			} else {
				component.isDarkMode = true;
			}			
			
			component.applyTheme();

			component.$logger("app/components/theme-switcher/toggleSwitch/isDarkMode: " + component.isDarkMode);

			// Set cookie
			Cookies.set('darkTheme', (component.isDarkMode) ? '1' : '0', { expires: 365 });
			
			// Submit form, or show notification for anonymous users
			if (component.userId > 0) {
				component.submitForm();
			} else {
				setTimeout(function () {
					component.$helper.confirmModal({
						title:
							"<h2>Tip van de dag</h2>Maak een gratis account aan en je voorkeur voor deze instelling wordt op ieder device/browser onthouden.<br><br>Wil je nu een account aanmaken?",
						onConfirm: function () {
							window.location = "/aanmelden";
						},
						onCancel: function () {},
					});
				}, 3000);
			}
		},
		submitForm() {

			var component = this;

			component.$logger("app/components/theme-switcher/submitForm");
						
			// Form data
			var form = component.$refs.themeForm;
			var formData = new FormData(form);
			
			// Custom data
			var data = {};
			
			// Add darkTheme value
			var fieldValue = (component.isDarkMode) ? '1' : '0';
			formData.append("fields[darkTheme]", fieldValue);
			
			// Request
			axios({
				method: "post",
				url: "/",
				responseType: "json",
				data: formData,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Accept: "application/json",
				},
			})
			.then(function (response) {
				if (response.data.error) {
					// Error
					component.$logger("app/components/theme-switcher/response/error");
				} else {
					// Success
					component.$logger("app/components/theme-switcher/response/success");
				}
			})
			.catch(function (result) {
				component.$logger("app/components/theme-switcher/catch", "error");
		
				// Json response
				var response = error.response.data;
				var errorCode = response.errorCode;
				var message = response.message;

			});
		},
	},
}
</script>

<style scoped>
.theme-switcher__button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	padding: 0;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.06);
	color: #e4e7eb;
	cursor: pointer;
	transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.theme-switcher__button:hover,
.theme-switcher__button:focus-visible {
	border-color: rgba(255, 61, 0, 0.55);
	background: rgba(255, 61, 0, 0.13);
	color: #ff6333;
	outline: none;
}

</style>
